module.exports = __webpack_public_path__ + "static/media/suppliers.69a3d278.png";